import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, List, Divider } from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import LampIcon from '@material-ui/icons/EmojiObjects';
import AddCommentIcon from '@material-ui/icons/AddComment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import HistoryIcon from '@material-ui/icons/History';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { ReactComponent as FactCheckIcon } from '../../assets/imgs/fact-check-icon.svg';

import config from '../../config';
import { Copyright } from '../Shared';
import { useWindowSize } from '../../hooks';
import { SidebarItem } from './SidebarItem';
import { useStyles, useStylesIcon } from './styles';
import { useIdeaDetailsController } from '../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function SidebarIdeaDetails() {
  const classes = useStyles();
  const classesIcon = useStylesIcon();
  const { t } = useTranslation();
  const [width] = useWindowSize();
  const { typeProfile: { type }, _id: userId } = useSelector((state) => state.user);
  const { ideaDetailsFlux, page } = useIdeaDetailsController();
  const ideaStepFlux = ideaDetailsFlux?.currentStepFlux?.ideaStepFlux;

  const menuItems = useMemo(() => [
    {
      key: 'general',
      icon: LampIcon,
      label: t('ideia_geral'),
      path: `/idea/${ideaDetailsFlux._id}/general`,
      show: true,
    },
    {
      key: 'engagement',
      icon: AddCommentIcon,
      label: t('engajamento'),
      path: `/idea/${ideaDetailsFlux._id}/engagement`,
      show: true,
    },
    {
      key: 'qualification',
      icon: ThumbUpIcon,
      label: t('avaliacao'),
      path: `/idea/${ideaDetailsFlux._id}/qualification`,
      show:
        (ideaStepFlux?.visualizationConfigs?.showInEvaluationTab &&
          (['admin', 'manager'].includes(type) ||
            (ideaDetailsFlux?.ideaContributorsCanApproveStep &&
              (ideaDetailsFlux?.contributors?.some(item => item?._id === userId) ||
               ideaDetailsFlux?.user?._id === userId)))
        )
    },
    {
      key: 'general-evaluation',
      icon: FactCheckIcon,
      label: t('avaliacao_geral'),
      path: `/idea/${ideaDetailsFlux._id}/general-evaluation`,
      isSvg: true,
      show: config.SHOW_PERSONALIZED_EVALUATION_ON_IDEA && ['admin', 'manager'].includes(type),
    },
    {
      key: 'execution',
      icon: BuildIcon,
      label: t('execucao').toLowerCase(),
      path: routeExecutionOrConclusion(),
      show: ideaStepFlux?.visualizationConfigs?.showInExecutionTab &&
            (ideaDetailsFlux?.contributors?.some(item => item?._id === userId) ||
            ideaDetailsFlux?.user?._id === userId ||
            type !== 'colaborator'),
      disabled: ideaStepFlux?.ideaExecutionIsRequired === false
    },
    {
      key: 'results',
      icon: AssignmentTurnedInIcon,
      label: t('resultados'),
      path: `/idea/${ideaDetailsFlux._id}/results`,
      show: true,
      disabled: ideaStepFlux?.showResultsInStep === false,
    },
    {
      key: 'history',
      icon: HistoryIcon,
      label: t('historico'),
      path: `/idea/${ideaDetailsFlux._id}/history`,
      show: true,
    },
    {
      key: 'similar-ideas',
      icon: EqualizerIcon,
      label: t('ideias_semelhantes'),
      path: `/idea/${ideaDetailsFlux._id}/similar-ideas`,
      show: true,
    },
  ]);

  function routeExecutionOrConclusion() {
    if (ideaStepFlux?.ideaExecutionIsRequired && ideaDetailsFlux?.statusIdea?.code !="EXECUTING") {
      return `/idea/${ideaDetailsFlux._id}/execution`;
    } else if (ideaStepFlux?.ideaFinishExecutionIsRequired && ideaDetailsFlux?.statusIdea?.code =="EXECUTING") {
      return `/idea/${ideaDetailsFlux._id}/conclusion`;
    }
  }
  
  return (
    <Box width="100%">
      <List style={{ padding: 0 }}>
        {menuItems.map(item => (
          <SidebarItem
            key={item.key}
            item={item}
            page={page}
            classes={classes}
            classesIcon={classesIcon}
          />
        ))}
      </List>

      {width > 960 && (
        <>
          <Divider style={{ marginTop: 16 }} />       
          <Copyright />
        </>
      )}
    </Box>
  );
}
